import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';

import { cn } from '#/lib/utils';

const CoverOverlay = ({
  className = null,
  size = 36,
  show = false,
  isLoading = false,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className={cn('cover_overlay bg-gray-400/65', className)}
      aria-busy={isLoading}
      aria-live="polite"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {isLoading ? (
          <Loader2
            className="animate-spin text-gray-700"
            size={size}
            aria-hidden
          />
        ) : null}
      </div>
    </div>
  );
};

CoverOverlay.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  show: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default CoverOverlay;
